export default "/_next/static/sounds/beach-sounds-b7d1b946eb893428a0dada03fc89e7fb.mp3";